import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { HttpClient } from '@angular/common/http'
import { AddPromoCodeData, offerFilter } from 'src/app/modules/offers/models/offer.model'
import { map } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class OffersService {
	constructor(private http: HttpClient) {}
	getOffersList(offersFilter: offerFilter) {
		return this.http
			.post(ApiEndPoint.OffersListApi, offersFilter)
			.pipe(map((result: any) => result.result as any))
	}
	deleteOffer(id: number) {
		return this.http.delete(`${ApiEndPoint.DeleteOfferApi}?id=${id}`)
	}
	updateOfferStatus(requestBody: any) {
		return this.http.put(`${ApiEndPoint.UpdateOfferStatusApi}`, requestBody)
	}

	getOffer(id: number) {
		return this.http.get(`${ApiEndPoint.GetPromoCodeApi}?id=${id}`)
	}
	UploadOfferImage(body: any) {
		return this.http.post(ApiEndPoint.UploadOfferImageApi, body)
	}
	SearchServiceProviders(body: any) {
		return this.http.post(ApiEndPoint.SearchPromoCodeServiceProvidersApi, body)
	}
	AddPromoCode(body: AddPromoCodeData) {
		return this.http.post(ApiEndPoint.AddPromoCodeApi, body)
	}
	updateOfferBasicInfo(body: any) {
		return this.http.put(`${ApiEndPoint.UpdatePromocodeBasicDataApi}`, body)
	}
	updatePromoCodeCountryAndPricing(body: any) {
		return this.http.put(
			`${ApiEndPoint.UpdatePromoCodeCountryAndPricingApi}`,
			body
		)
	}
}
